import React from "react";

interface MyLeaveCalendarPathOutlinePriorProps {
  color: string;
}

export const MyLeaveCalendarPathOutlinePrior = ({ color }: MyLeaveCalendarPathOutlinePriorProps) => {
  return (
    <React.Fragment>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M 12.910059,0 16.041827,0.00593567 16.039654,1.9814606 12.910059,2 c -0.55259,0.00327 -1.0807,0.2287 -1.4588,0.6318 l -8.9099802,9.5 c -0.7217,0.7694 -0.7217,1.967 0,2.7364 l 8.9099802,9.5 c 0.3781,0.4031 0.9062,0.6318 1.4588,0.6318 l 3.128706,0.0074 0.0046,1.979368 -3.133315,0.0069 c -1.105297,0.0024 -2.1614,-0.4511 -2.9175402,-1.2573 l -8.91004,-9.5 c -1.44330505,-1.5388 -1.44330505,-3.934 0,-5.4728 l 8.91004,-9.5 C 10.748659,0.457399 11.804759,0 12.910059,0 Z"
        fill={color}
      />
    </React.Fragment>
  );
};

export default MyLeaveCalendarPathOutlinePrior;
